export function useDictionary<T, K extends keyof T>(
  dictionary: T,
  propertyName: K
) {
  return dictionary[propertyName];
}
